module.exports = __webpack_public_path__ + "static/avatar-7b86de3d10fd355db730ea780ab85f0f.jpg";